<template>
  <div class="col-lg-6">
    <div class="card">
      <div class="card-body">
        <validation-observer ref="passwordForm">
          <b-form @submit.prevent="submitForm">
            <b-row>
              <!-- BATTERY LEVEL NOTIFICATION ACTIVATION -->
              <b-col cols="12">
                <b-form-group
                  label="Notifikacija o stanju baterije"
                  label-for="isNotifyBatteryLevelActive"
                  label-cols-md="4"
                >
                  <b-form-checkbox
                    v-model="model.isNotifyBatteryLevelActive"
                    checked="true"
                    class="custom-control-success"
                    name="check-button"
                    switch
                  />
                </b-form-group>
              </b-col>

              <!-- BATTERY LEVEL FOR NOTIFICATION -->
              <b-col cols="12" v-if="model.isNotifyBatteryLevelActive">
                <b-form-group
                  label="Nivo baterije za obavještavanje (V)"
                  label-for="batteryLevel"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="batteryLevel"
                    vid="batteryLevel"
                    rules="required|between:1,5"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="BatteryIcon" />
                      </b-input-group-prepend>

                      <b-form-input
                        v-model="model.notifyBatteryLevel"
                        id="batteryLevel"
                        type="text"
                        placeholder="Nivo baterije za obavještavanje"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- COW CUSTOM MARK TIME -->
              <b-col cols="12">
                <b-form-group
                  label="Vrijeme za posebno markiranje grla (broj sati)"
                  label-for="cowCustomMarkTime"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="cowCustomMarkTime"
                    vid="cowCustomMarkTime"
                    rules="required|integer|positive"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="ClockIcon" />
                      </b-input-group-prepend>

                      <b-form-input
                        v-model="model.cowCustomMarkTime"
                        id="cowCustomMarkTime"
                        type="text"
                        placeholder="Vrijeme za posebno markiranje grla (broj sati)"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- VIRTUAL FENCE ACTIVATION -->
              <b-col cols="12">
                <b-form-group
                  label="Virtuelna ograda"
                  label-for="isVirtualFenceActive"
                  label-cols-md="4"
                >
                  <b-form-checkbox
                    v-model="model.isVirtualFenceActive"
                    checked="true"
                    class="custom-control-success"
                    name="check-button"
                    switch
                  />
                </b-form-group>
              </b-col>

              <!-- NOTIFICATION EMAILS -->
              <b-col cols="12">
                <b-form-group
                  label="Email za notifikovanje"
                  label-for="notificationEmails"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="notificationEmails"
                    vid="notificationEmails"
                    rules="required|email"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="AtSignIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="model.notificationEmails"
                        id="notificationEmails"
                        type="text"
                        placeholder="Email za notifikovanje"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- submit and reset -->
              <b-col offset-md="4">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                >
                  Sačuvaj
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
  BAlert,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { heightFade } from "@core/directives/animations";
import { required, positive, between, integer } from "@validations";
import store from "@/store/index";
import { mapState } from "vuex";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BAlert,
  },
  directives: {
    "height-fade": heightFade,
    Ripple,
  },
  beforeDestroy() {
    store.commit("settings/SET_MODEL");
  },
  mounted() {
    localize("en", {
      code: "en",
      fields: {
        batteryLevel: {
          required: "Polje je obavezno",
          between: "Vrijednost mora biti broj između 1 i 5",
        },
        cowCustomMarkTime: {
          required: "Polje je obavezno",
          integer: "Vrijednost mora biti cijeli broj",
        },
        notificationEmails: {
          required: "Polje je obavezno",
          email: "Morate unijeti validnu email adresu",
        },
      },
    });
  },
  computed: {
    ...mapState({
      model: (state) => state.settings.model,
    }),
  },
  methods: {
    submitForm() {
      var $this = this;
      $this.deviceAlredyExists = false;
      this.$refs.passwordForm.validate().then((success) => {
        if (success) {
          var $this = this;
          store
            .dispatch("settings/CREATE_UPDATE_SETTINGS", this.model)
            .then((response) => {
              $this.$swal({
                position: "bottom-end",
                icon: "success",
                title: "Uspješno ste ažurirali podešavanja",
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              $this.$router.push({ name: "SettingsIndex" });
            })
            .catch((error) => {});
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-alert {
  padding-bottom: 0;
}
.form-control:disabled {
  background-color: white;
}
#deviceId {
  font-weight: bold;
}
</style>
